import React from 'react';
import { Shield, AlertTriangle, Scale, FileText, Mail, Building2, Lock } from 'lucide-react';
import TermsContent from '../components/TermsContent';

const Terms = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white rounded-xl shadow-sm overflow-hidden">
          {/* Header */}
          <div className="border-b border-gray-200 bg-gray-50 p-6">
            <div className="flex items-center space-x-3">
              <Scale className="h-8 w-8 text-indigo-600" />
              <h1 className="text-2xl font-bold text-gray-900">Terms and Conditions</h1>
            </div>
            <p className="mt-2 text-gray-600">Last updated: {new Date().toLocaleDateString()}</p>
          </div>

          {/* Important Disclaimer Banner */}
          <div className="bg-yellow-50 border-b border-yellow-200 p-4">
            <div className="flex items-start">
              <AlertTriangle className="h-5 w-5 text-yellow-500 mt-0.5 mr-2 flex-shrink-0" />
              <div>
                <h3 className="text-lg font-semibold text-yellow-800 mb-2">Important Disclaimer</h3>
                <p className="text-yellow-700">
                  SubleaseHero is a platform operated by 21st Q LTD that connects property owners and leaseholders with potential subletters. We do not verify the legality of subletting arrangements, compliance with lease agreements, or the accuracy of Listings. Users are solely responsible for ensuring their actions comply with their lease agreements, local laws, and regulations. SubleaseHero and 21st Q LTD expressly disclaim any and all liability arising from the use of our Services.
                </p>
              </div>
            </div>
          </div>

          {/* Key Features Section */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 bg-gray-50 p-6">
            <div className="flex flex-col items-center text-center p-4">
              <Shield className="h-8 w-8 text-indigo-600 mb-3" />
              <h3 className="font-semibold mb-2">Legal Compliance</h3>
              <p className="text-sm text-gray-600">Users must ensure compliance with lease agreements and local laws</p>
            </div>
            <div className="flex flex-col items-center text-center p-4">
              <Lock className="h-8 w-8 text-indigo-600 mb-3" />
              <h3 className="font-semibold mb-2">Service Fee</h3>
              <p className="text-sm text-gray-600">5% non-refundable fee based on one month's rent</p>
            </div>
            <div className="flex flex-col items-center text-center p-4">
              <Building2 className="h-8 w-8 text-indigo-600 mb-3" />
              <h3 className="font-semibold mb-2">Platform Only</h3>
              <p className="text-sm text-gray-600">We facilitate connections but are not party to agreements</p>
            </div>
          </div>

          {/* Full Legal Terms */}
          <div className="p-6">
            <TermsContent />
          </div>

          {/* Contact Information */}
          <div className="bg-gray-50 p-6 border-t border-gray-200">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">Contact Information</h2>
            <div className="space-y-4">
              <div className="flex items-start space-x-3">
                <Mail className="h-5 w-5 text-gray-400 mt-0.5" />
                <div>
                  <p className="font-medium">Email</p>
                  <a href="mailto:support@subleasehero.com" className="text-indigo-600 hover:text-indigo-700">
                    support@subleasehero.com
                  </a>
                </div>
              </div>
              <div className="flex items-start space-x-3">
                <Building2 className="h-5 w-5 text-gray-400 mt-0.5" />
                <div>
                  <p className="font-medium">Mailing Address</p>
                  <address className="not-italic">
                    SubleaseHero<br />
                    c/o 21st Q LTD<br />
                    6890 O'Bannon Drive<br />
                    Las Vegas, Nevada 89117<br />
                    Clark County, Nevada
                  </address>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Terms;